import { create } from 'zustand'
import { api } from '../utils/api'
import type { DatacenterConfig } from '../types'
import { reconcileActiveDcCode } from '../utils/dcContext.logic'

interface DcState {
  datacenters: DatacenterConfig[]
  loading: boolean
  error: string | null
  fetchDatacenters: () => Promise<void>
  activeDcCode: string | null
  setActiveDcCode: (code: string | null) => void
}

export const useDcStore = create<DcState>((set) => ({
  datacenters: [],
  loading: false,
  error: null,
  activeDcCode: localStorage.getItem('activeDcCode'),

  fetchDatacenters: async () => {
    set({ loading: true, error: null })
    try {
      const res = await api.get<DatacenterConfig[]>('/api/datacenters')
      const codes = res.data.map(d => d.code)
      const next = reconcileActiveDcCode(localStorage.getItem('activeDcCode'), codes)
      if (next) localStorage.setItem('activeDcCode', next)
      else localStorage.removeItem('activeDcCode')
      set({ datacenters: res.data, loading: false, activeDcCode: next })
    } catch (err: any) {
      set({ error: err.message || 'Ошибка загрузки ЦОДов', loading: false })
    }
  },

  setActiveDcCode: (code: string | null) => {
    if (!code) {
      localStorage.removeItem('activeDcCode')
      set({ activeDcCode: null })
      return
    }
    set({ activeDcCode: code })
    localStorage.setItem('activeDcCode', code)
  }
}))
